module.exports = __webpack_public_path__ + "static/media/house-and-garden.4e6a0a43.svg";